import { css } from 'emotion'

export const TaskStatusesMainStyles = css``
